import { OrderForm } from "./OrderForm";
import { ArrowRightIcon } from "./Icons";
import { siteConfig } from "../site-config";

export function OrderSection() {
  return (
    <section className="order-section section-light" id="order" aria-labelledby="order-title">
      <div className="container order-grid">
        <div className="order-intro" data-reveal>
          <h2 id="order-title">Siap memulai proyek?</h2>
          <p>Ceritakan kebutuhanmu. Kami akan membantu menentukan desain, material, waktu, dan estimasi biaya.</p>
          <figure className="order-media">
            <img
              alt="Prototype enclosure Morolab dengan peralatan ukur"
              height="1086"
              loading="lazy"
              src="/images/work-enclosure.webp"
              width="1448"
            />
          </figure>
        </div>
        <div data-reveal>
          {siteConfig.googleFormUrl ? (
            <div className="order-link-card">
              <h3>Kirim permintaan proyek</h3>
              <p>Isi formulir Morolab untuk menjelaskan kebutuhanmu dan melampirkan file desain atau referensi.</p>
              <a className="button button-primary submit-button" href={siteConfig.googleFormUrl} rel="noreferrer" target="_blank">
                Isi formulir pesanan
                <ArrowRightIcon />
              </a>
              <p className="order-link-note">Untuk mengunggah file, Google akan meminta kamu masuk ke akun Google.</p>
              {siteConfig.whatsappUrl ? (
                <a className="button button-outline whatsapp-button" href={siteConfig.whatsappUrl} rel="noreferrer" target="_blank">
                  Atau konsultasi lewat WhatsApp
                  <ArrowRightIcon />
                </a>
              ) : null}
            </div>
          ) : (
            <OrderForm />
          )}
        </div>
      </div>
    </section>
  );
}
